import { render, staticRenderFns } from "./GoodsDetailsList.vue?vue&type=template&id=2cea9b05"
import script from "./GoodsDetailsList.vue?vue&type=script&lang=js"
export * from "./GoodsDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports